import React from "react";

const MdmFleetViewContextBar = ({
  viewingLabel,
  selectedCount = 0,
  columnsPanelRef,
  isColumnsPanelOpen,
  setIsColumnsPanelOpen,
  activeManagedColumnsForPanel,
  pendingManagedColumnsForPanel,
  moveColumnToPending,
  moveColumnToActive,
  folderActionError,
  foldersError,
}) => (
  <div className="px-4 py-3 border-b border-outline-variant/5 flex items-center justify-between gap-3 bg-surface-container-low/50">
    <p className="text-xs text-on-surface-variant flex flex-wrap items-center gap-2">
      Viewing <span className="font-semibold text-on-surface">{viewingLabel}</span>
      {selectedCount > 0 && (
        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-primary/10 text-primary font-semibold">
          <span className="material-symbols-outlined text-sm">check_box</span>
          {selectedCount} selected
        </span>
      )}
    </p>
    <div className="flex items-center gap-3">
      <details className="relative" ref={columnsPanelRef} open={isColumnsPanelOpen}>
        <summary
          className="list-none cursor-pointer px-3 py-1.5 rounded-lg text-xs font-semibold bg-surface-container-low text-on-surface-variant hover:bg-surface-container-high transition-colors"
          onClick={(event) => {
            event.preventDefault();
            setIsColumnsPanelOpen((prev) => !prev);
          }}
        >
          Columns
        </summary>
        <div className="absolute right-0 mt-2 w-80 rounded-lg border border-outline-variant/20 bg-surface-container-lowest shadow-xl p-3 z-20">
          <p className="text-[11px] font-semibold text-on-surface mb-2">Active columns</p>
          {activeManagedColumnsForPanel.length === 0 ? (
            <p className="text-[11px] text-on-surface-variant mb-3">No active movable columns.</p>
          ) : (
            <div className="space-y-1 mb-3">
              {activeManagedColumnsForPanel.map((column) => (
                <div key={column.key} className="flex items-center justify-between gap-2">
                  <span className="text-xs text-on-surface-variant">
                    {column.panelLabel || column.label}
                  </span>
                  <button
                    type="button"
                    className="px-2 py-1 rounded-md text-[10px] font-semibold bg-surface-container-low text-on-surface-variant hover:bg-surface-container-high transition-colors"
                    onClick={() => moveColumnToPending(column.key)}
                  >
                    Move to pending
                  </button>
                </div>
              ))}
            </div>
          )}
          <p className="text-[11px] font-semibold text-on-surface mb-2">Pending columns</p>
          {pendingManagedColumnsForPanel.length === 0 ? (
            <p className="text-[11px] text-on-surface-variant">No pending columns.</p>
          ) : (
            <div className="space-y-1">
              {pendingManagedColumnsForPanel.map((column) => (
                <div key={column.key} className="flex items-center justify-between gap-2">
                  <span className="text-xs text-on-surface-variant">
                    {column.panelLabel || column.label}
                  </span>
                  <button
                    type="button"
                    className="px-2 py-1 rounded-md text-[10px] font-semibold bg-primary/10 text-primary hover:bg-primary/20 transition-colors"
                    onClick={() => moveColumnToActive(column.key)}
                  >
                    Add column
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </details>
      {folderActionError && <p className="text-xs text-error font-semibold">{folderActionError}</p>}
      {foldersError && !folderActionError && (
        <p className="text-xs text-error font-semibold">{foldersError}</p>
      )}
    </div>
  </div>
);

export default MdmFleetViewContextBar;
